import React from 'react';
import { StyledServicesCards } from './HomeSectionStyles';
import { Content } from '../../../components/ThemeProvider/ThemeStyle';
import {home_services} from '../homeServices'
import HomeServicesCards from './HomeServicesCards';

function HomeServices({contentWidth}) {

  return (
    <Content contentWidth={contentWidth}>
        <StyledServicesCards>
          {Object.values(home_services).map((metadata, index) => (
            <HomeServicesCards
              key={index}
              metadata={metadata}
            />
            ))
          }
        </StyledServicesCards>
    </Content>
  );
}

export default HomeServices;
